module.exports = __webpack_public_path__ + "img/share-symbol@1.5x.c68db3e9.svg";